import styled from "styled-components";

export const EmployerBrandingWrapper = styled.div`
  display: flex;
  margin-top: 97px;
  align-items: center;
  flex-direction: column;
`;

export const Header = styled.div`
  font-family: "Rubik", sans-serif;
  font-size: 38px;
  font-style: normal;
  font-weight: 500;
  line-height: 47px;
  letter-spacing: -0.76px;
`;

export const SubHeader = styled.span`
  font-family: "Rubik", sans-serif;
  font-size: 16px;
  color: #4a4a51;
  line-height: 28px;
  margin-top: 10px;
`;
